import { Box, Divider, Image, TextLink, Typography } from '@drone-js/core';
import React from 'react';
import { mapDispatchToProps, mapStateToProps, SelectedOfferSummaryCardProps } from 'component/page/detail/FloatingSidePanel/SelectedOfferSummaryCard.selectors';
import { connect } from 'react-redux';
import { StringFormatter } from '@agoda/react-handyman';
import { getCounterProps } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardPaxPanel/PaxCounter/paxUtils';
import { OfferCardFooterType } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter.selectors';
import OfferCardFooter from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/OfferCardFooter';
import SummaryInfoText from 'component/page/detail/FloatingSidePanel/SummaryInfoText';
import SummaryPaxInfoText from 'component/page/detail/FloatingSidePanel/SummaryPaxInfoText';
import { TIME_KEY } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferOptions/OfferOptionsUtils';
import DiscountInfoText from 'component/page/detail/FloatingSidePanel/DiscountInfoText';
import { ExperimentId } from 'core/type/ExperimentId';
import Experiment from 'component/common/Experiment/Experiment';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesBookingOptionsEditButtonClickEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesBookingOptionsEditButtonClickEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';

const SelectedOfferSummaryCard: React.FC<SelectedOfferSummaryCardProps> = (props) => {
    const {
        offerGroupTitle,
        cms,
        currency,
        pricePerPax,
        pax,
        bookingRequirement,
        image,
        locale,
        dateTimeText,
        sortedSelectedSpecifications,
        appliedPromocodeItem,
        packageOptionsHref,
    } = props;
    const getCounterPropsFromPaxRequirement = React.useMemo(() => getCounterProps(cms, pax), [cms, pax]);
    const editButtonRef = React.useRef<HTMLAnchorElement>(null);
    const editOffer = () => {
        trackElementEvent<ActivitiesBookingOptionsEditButtonClickEventActivitiesFieldsV1>(ActivitiesBookingOptionsEditButtonClickEventActivitiesManifestV1.ids, {});
        props.onEditOfferClick(packageOptionsHref);
        editButtonRef.current?.blur();
    };

    return (
        <>
            <Box pb="16" display="flex" flexDirection="row" justifyContent="space-between" data-testid="offer-summary-card-title">
                <Experiment.WhenA id={ExperimentId.ACT_4926}>
                    <Typography variant="heading-default" pe="8" pb="8">
                        {offerGroupTitle}
                    </Typography>
                </Experiment.WhenA>
                <Experiment.WhenB id={ExperimentId.ACT_4926}>
                    <div>
                        <Typography variant="heading-default" pe="8" pb="8">
                            {offerGroupTitle}
                        </Typography>
                        <TextLink
                            data-test-id="edit-offer-button"
                            data-element-name="activities-booking-options-edit-button"
                            ref={editButtonRef}
                            onClick={editOffer}
                            hierarchy="primary"
                            label={cms[45805]}
                            leadingIcon="fill.symbol.edit"
                            href={`#${packageOptionsHref}`}
                        />
                    </div>
                </Experiment.WhenB>
                {image && image.url && <Image src={image.url} alt={StringFormatter.format(cms[321481], 1, 1)} width="60px" height="60px" borderRadius="8" />}
            </Box>
            <SummaryInfoText cms={cms} label={cms[3363]} value={dateTimeText} />
            {sortedSelectedSpecifications.map((spec) => (
                <SummaryInfoText cms={cms} key={spec.key} label={spec.key === TIME_KEY ? cms[126980] : spec.key} value={spec.specification} />
            ))}
            <Divider mt="12" mb="16" />
            {bookingRequirement.paxRequirements.map((paxRequirement) => (
                <SummaryPaxInfoText
                    key={paxRequirement.code}
                    cms={cms}
                    paxCounter={getCounterPropsFromPaxRequirement(paxRequirement)}
                    currency={currency}
                    pricePerPaxList={pricePerPax}
                    locale={locale}
                />
            ))}
            <DiscountInfoText discountItem={appliedPromocodeItem} cms={cms} currency={currency} locale={locale} />
            <Divider mt="12" mb="16" />
            {/* We only have one SummaryCard so we use first index */}
            <OfferCardFooter footerType={OfferCardFooterType.SummaryCard} offerIndex={0} />
        </>
    );
};

SelectedOfferSummaryCard.displayName = 'SelectedOfferSummaryCard';

export default connect(mapStateToProps, mapDispatchToProps)(SelectedOfferSummaryCard);
